export const getMarkdownFilename = (title: string, fallbackName: string = 'document'): string => {
    const sanitized = (title || fallbackName)
        .replace(/[/\\?%*:|"<>\u0000-\u001f]/g, '')
        .replace(/\s+/g, ' ')
        .trim()
        .replace(/[. ]+$/, '')
    return `${sanitized.length > 0 ? sanitized : fallbackName}.md`
}

export const downloadMarkdown = (filename: string, content: string): void => {
    const blob = new Blob([content], {type: 'text/markdown;charset=utf-8;'})
    const link = document.createElement('a')
    const url = URL.createObjectURL(blob)
    link.setAttribute('href', url)
    link.setAttribute('download', filename)
    link.style.visibility = 'hidden'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
}
